import { MapPin, Phone, Mail, ArrowUpRight } from "lucide-react";

const links = {
  kurumsal: [
    { label: "Hakkımızda", href: "#hakkimizda" },
    { label: "Misyon & Vizyon", href: "#hakkimizda" },
    { label: "Kariyer", href: "#iletisim" },
    { label: "Basın", href: "#iletisim" },
  ],
  hizmetler: [
    { label: "Konut Projeleri", href: "#projeler" },
    { label: "Ticari Yapılar", href: "#projeler" },
    { label: "Endüstriyel Tesisler", href: "#projeler" },
    { label: "Altyapı", href: "#projeler" },
  ],
  yasal: [
    { label: "Gizlilik Politikası", href: "#" },
    { label: "Kullanım Koşulları", href: "#" },
    { label: "KVKK Aydınlatma Metni", href: "#" },
    { label: "Çerez Politikası", href: "#" },
  ],
};

export default function Footer() {
  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#0C0C0C] text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        {/* Top */}
        <div className="pt-16 sm:pt-20 pb-12 border-b border-white/10">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
            <div>
              <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter logo-hover group cursor-default" style={{ fontFamily: "Outfit" }}>
                <span className="logo-letter-orange text-[#FF5A00]">BCT</span> <span className="logo-letter-yapi">YAPI</span>
              </h2>
              <p className="text-gray-500 mt-3 max-w-md text-sm leading-relaxed">
                Bct Yapi İnşaat Mühendislik Sanayi ve Ticaret Limited Şirketi
              </p>
            </div>
            <a href="#anasayfa" onClick={(e) => go(e, "#anasayfa")} className="btn-modern btn-filled text-sm self-start sm:self-auto">
              Yukarı Çık
              <ArrowUpRight size={15} />
            </a>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-10 py-12 sm:py-16">
          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-5" style={{ fontFamily: "Outfit" }}>İletişim</h4>
            <div className="space-y-3">
              <a href="tel:+905454814275" className="footer-link flex items-center gap-2" data-testid="footer-phone">
                <Phone size={13} className="text-[#FF5A00]" /> 0545 481 42 75
              </a>
              <a href="mailto:info@bctyapi.com" className="footer-link flex items-center gap-2" data-testid="footer-email">
                <Mail size={13} className="text-[#FF5A00]" /> info@bctyapi.com
              </a>
              <div className="footer-link flex items-start gap-2">
                <MapPin size={13} className="text-[#FF5A00] mt-0.5 flex-shrink-0" />
                <span>Gültepe Mh. Eflatun Cd. ESF İşhanı<br/>No:26/210 Batman, Batman</span>
              </div>
            </div>
          </div>

          {/* Kurumsal */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-5" style={{ fontFamily: "Outfit" }}>Kurumsal</h4>
            <ul className="space-y-2.5">
              {links.kurumsal.map((l) => (
                <li key={l.label}><a href={l.href} onClick={(e) => go(e, l.href)} className="footer-link">{l.label}</a></li>
              ))}
            </ul>
          </div>

          {/* Hizmetler */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-5" style={{ fontFamily: "Outfit" }}>Hizmetler</h4>
            <ul className="space-y-2.5">
              {links.hizmetler.map((l) => (
                <li key={l.label}><a href={l.href} onClick={(e) => go(e, l.href)} className="footer-link">{l.label}</a></li>
              ))}
            </ul>
          </div>

          {/* Yasal */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-gray-500 mb-5" style={{ fontFamily: "Outfit" }}>Yasal</h4>
            <ul className="space-y-2.5">
              {links.yasal.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="footer-link" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, '-').replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ç/g, 'c').replace(/ş/g, 's')}`}>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="py-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-gray-600">&copy; {new Date().getFullYear()} BCT Yapı. Tüm hakları saklıdır.</p>
          <div className="flex gap-5">
            <a href="#" className="text-xs text-gray-600 hover:text-gray-400 transition-colors">Gizlilik</a>
            <a href="#" className="text-xs text-gray-600 hover:text-gray-400 transition-colors">Koşullar</a>
            <a href="#" className="text-xs text-gray-600 hover:text-gray-400 transition-colors">KVKK</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
